import { render, staticRenderFns } from "./LiveRoomItem.vue?vue&type=template&id=6dbb8acc&scoped=true&"
import script from "./LiveRoomItem.vue?vue&type=script&lang=ts&"
export * from "./LiveRoomItem.vue?vue&type=script&lang=ts&"
import style0 from "./LiveRoomItem.vue?vue&type=style&index=0&id=6dbb8acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbb8acc",
  null
  
)

export default component.exports